import React, { Suspense } from 'react'
import { useReapitConnect } from '@reapit/connect-session'
import { reapitConnectBrowserSession } from './reapit-connect-session'
import { Navigate, useLocation } from 'react-router'
import { Loader, MainContainer, PageContainer } from '@reapit/elements'

export const PrivateRouteWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { connectSession, connectInternalRedirect } = useReapitConnect(reapitConnectBrowserSession)
  const location = useLocation()

  if (!connectSession) {
    return (
      <MainContainer hasGreyBackground>
        <PageContainer>
          <Loader fullPage />
        </PageContainer>
      </MainContainer>
    )
  }

  if (connectInternalRedirect && location?.pathname !== connectInternalRedirect) {
    return <Navigate to={connectInternalRedirect} />
  }

  return (
    <MainContainer>
      <Suspense fallback={<Loader fullPage />}>{children}</Suspense>
    </MainContainer>
  )
}

export default PrivateRouteWrapper
